<script>
    import connector from "images/hs315-line.svg";

    export let iconPath;
    export let iconTheme;

    export let iconNav;
    export let iconUpDown;
    export let ledText;

    export let foreground;
</script>

<div class="pc__step-connector pc__step-connector--{iconTheme}">{@html connector}</div>

<div class="pc__icon pc__icon--up-down"><img alt="up-down" src="{iconPath}/{iconUpDown}-up-down.svg" /></div>
<div class="pc__icon pc__icon--nav"><img alt="nav" src="{iconPath}/{iconNav}-directions.svg" /></div>
<div class="pc__icon pc__icon--off"><img alt="off" src="{iconPath}/off.svg" /></div>
<div class="pc__icon pc__icon--on"><img alt="on" src="{iconPath}/on.svg" /></div>

<div class="pc__icon pc__icon--left-1"><img alt="left-1" src="{iconPath}/alert.svg" /></div>
<div class="pc__icon pc__icon--left-2"><img alt="left-2" src="{iconPath}/bus.svg" /></div>
<div class="pc__icon pc__icon--left-3"><img alt="left-3" src="{iconPath}/type.svg" /></div>

<div class="pc__icon pc__icon--step-1"><img alt="step-1" src="{iconPath}/power.svg" /></div>
<div class="pc__icon pc__icon--step-3"><img alt="step-3" src="{iconPath}/factory.svg" /></div>
<div class="pc__icon pc__icon--step-4"><img alt="step-4" src="{iconPath}/{iconUpDown}-gcb.svg" /></div>
<div class="pc__icon pc__icon--step-5"><img alt="step-5" src="{iconPath}/current.svg" /></div>

<div class="pc__icon pc__icon--bottom-1"><img alt="bottom-1" src="{iconPath}/zero.svg" /></div>
<div class="pc__icon pc__icon--bottom-2"><img alt="bottom-2" src="{iconPath}/hand.svg" /></div>
<div class="pc__icon pc__icon--bottom-3"><img alt="bottom-3" src="{iconPath}/auto.svg" /></div>

<div class="pc__led pc__led--left-1"></div>
<div class="pc__led pc__led--left-2"></div>
<div class="pc__led pc__led--left-3"></div>

<div class="pc__led pc__led--step-1"></div>
<div class="pc__led pc__led--step-2"></div>
<div class="pc__led pc__led--step-3"></div>
<div class="pc__led pc__led--step-4"></div>
<div class="pc__led pc__led--step-5"></div>

<div class="pc__led pc__led--bottom-1"></div>
<div class="pc__led pc__led--bottom-2"></div>
<div class="pc__led pc__led--bottom-3"></div>

{#if ledText}
<div class="pc__text pc__text--gcb" style="color: {foreground};">GCB</div>
{/if}